import React from "react";
import { FeatherRefreshCw, FeatherSearch } from "@subframe/core";
import { Button } from "../../../../ui/components/Button";
import { TextField } from "../../../../ui/components/TextField";
import { SortDropdown } from "../../../../shared/presentation/components/SortDropdown";
import {
  CashBankSortField,
  CashBankSortOrder,
  CashBankTransactionStatus,
} from "../../domain";
import { CashBankStatusFilterPills } from "./CashBankStatusFilterPills";

export interface CashBankSortState {
  by: CashBankSortField;
  order: CashBankSortOrder;
  label: string;
}

interface CashBankTransactionToolbarProps {
  status: CashBankTransactionStatus;
  onStatusChange: (value: CashBankTransactionStatus) => void;
  searchTerm: string;
  onSearchTermChange: (value: string) => void;
  sort: CashBankSortState;
  onSortChange: (
    sortBy: CashBankSortField,
    sortOrder: CashBankSortOrder,
    label: string,
  ) => void;
  onRefresh: () => void;
  disabled?: boolean;
}

const SORT_OPTIONS = [
  {
    value: "date_desc",
    label: "Date: Newest First",
    by: "date",
    order: "desc",
  },
  {
    value: "date_asc",
    label: "Date: Oldest First",
    by: "date",
    order: "asc",
  },
  {
    value: "updated_at_desc",
    label: "Modified Date: Newest First",
    by: "updated_at",
    order: "desc",
  },
  {
    value: "updated_at_asc",
    label: "Modified Date: Oldest First",
    by: "updated_at",
    order: "asc",
  },
];

export const CashBankTransactionToolbar: React.FC<
  CashBankTransactionToolbarProps
> = ({
  status,
  onStatusChange,
  searchTerm,
  onSearchTermChange,
  sort,
  onSortChange,
  onRefresh,
  disabled = false,
}) => (
  <div className="flex w-full items-center justify-between gap-4 mobile:flex-col mobile:items-start">
    <CashBankStatusFilterPills value={status} onChange={onStatusChange} />
    <div className="flex flex-wrap items-center gap-4">
      <TextField
        className="h-auto w-64 flex-none"
        variant="filled"
        label=""
        helpText=""
        icon={<FeatherSearch />}
      >
        <TextField.Input
          placeholder="Search transactions..."
          value={searchTerm}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onSearchTermChange(event.target.value)
          }
        />
      </TextField>
      <SortDropdown
        currentSort={sort}
        onSortChange={(sortBy, sortOrder, label) =>
          onSortChange(
            sortBy as CashBankSortField,
            sortOrder as CashBankSortOrder,
            label,
          )
        }
        options={SORT_OPTIONS}
        disabled={disabled}
      />
      <Button
        variant="neutral-tertiary"
        icon={<FeatherRefreshCw />}
        onClick={onRefresh}
        disabled={disabled}
      >
        Refresh
      </Button>
    </div>
  </div>
);
